import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from 'ish-core/services/api/api.service';

import { QuickOrder, UpdateQuickOrderItem } from '../../models/custom-quickorder/custom-quickorder.model';
import { AvailableOptions, QuickorderApiService } from '../quickorder-api/quickorder-api.service';

@Injectable({ providedIn: 'root' })
export class CustomQuickorderService {
  constructor(private apiService: ApiService, private quickorderApiService: QuickorderApiService) {}

  getCustomQuickorder(): Observable<QuickOrder> {
    return this.apiService.get('quickorder');
  }
  createCustomQuickorder(quickOrderItems: UpdateQuickOrderItem[]): Observable<QuickOrder> {
    const createQuickOrderPayload = { items: quickOrderItems };
    return this.apiService.post('quickorder', createQuickOrderPayload);
  }
  updateCustomQuickorder(itemId: string, quickOrderItem: UpdateQuickOrderItem): Observable<QuickOrder> {
    return this.apiService.put(`quickorder/${itemId}`, quickOrderItem);
  }
  deleteCustomQuickorder(itemLineIds: string[]): Observable<QuickOrder> {
    const deleteQuickOrderPayload = { itemLineIds };
    const options: AvailableOptions = {
      body: deleteQuickOrderPayload,
    };
    return this.quickorderApiService.delete('quickorder', options);
  }
}
